import { render, staticRenderFns } from "./About.vue?vue&type=template&id=0b4e1194&scoped=true&"
import script from "./About.js?vue&type=script&lang=js&"
export * from "./About.js?vue&type=script&lang=js&"
import style0 from "./About.scss?vue&type=style&index=0&id=0b4e1194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e1194",
  null
  
)

export default component.exports